/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_Select_DeveloperInputs */



/**
* | output |
* | --- |
* | "Select Developer" |
*
* @param {Options_Cli_Select_DeveloperInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_select_developer = /** @type {((inputs?: Options_Cli_Select_DeveloperInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Select_DeveloperInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner le développeur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entwickler auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona Sviluppatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите разработчика")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar desarrollador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择开发商")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開発者を選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डेवलपर का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o desenvolvedor")
	return /** @type {LocalizedString} */ ("Select Developer")
});